import React, { SVGProps } from 'react'
const SvgPhone = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <path
      fill={props.fill || '#1B2C4F'}
      fillRule="evenodd"
      d="M6.802 5.378c0-.485.393-.878.878-.878h8.14c.485 0 .878.393.878.878V18.4a.878.878 0 0 1-.878.878H7.68a.878.878 0 0 1-.878-.878V5.378ZM7.68 3a2.378 2.378 0 0 0-2.378 2.378V18.4A2.378 2.378 0 0 0 7.68 20.78h8.14a2.378 2.378 0 0 0 2.378-2.378V5.378A2.378 2.378 0 0 0 15.82 3H7.68Zm4.07 12.773a1 1 0 1 0 0 2h.008a1 1 0 0 0 0-2h-.008Z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgPhone
